import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { videoQuery } from '@/components/video/VideoLibrary';
import { VideoThumbnail } from '@/components/video/VideoThumbnail';

export function HomeTourPhoto({ id, src, title, eager }: { id: string; src?: string; title: string; eager: boolean }) {
  const [failed,setFailed] = useState<string | null>(null);
  const { data: videos=[] } = useQuery(videoQuery);
  const poster = videos.find(v=>v.productIds.includes(id))?.poster ?? null;
  if ((!src || failed===src) && poster) return <VideoThumbnail src={poster} title={title}/>;
  return <img src={src} alt={title} loading={eager?'eager':'lazy'} decoding="async" width={400} height={250} className="home-tour-main-image" onError={()=>setFailed(src??'')}/>;
}